import * as eHubApi from "./data.service";

export function createPO(req) {
  return eHubApi.post("/api/po/create", req);
}

export function editPO(req) {
  return eHubApi.put(
    `/api/po/edit?poNumber=${req.poNumber}&customerCode=${req.customerCode}`,
    req.req
  );
}

export function getPO(req) {
  return eHubApi.get(`/api/po/get?poNumber=${req.poNumber}&customerCode=${req.customerCode}`);
}

export function getOpenPO(req) {
  return eHubApi.get(
    `/api/po/get-open-po?poNumber=${req.poNumber}&customerCode=${req.customerCode}`
  );
}

export function deletePO(req) {
  return eHubApi.del(`/api/po/delete?poNumber=${req.poNumber}&customerCode=${req.customerCode}`);
}

export function getPOList(req) {
  return eHubApi.get(`/api/po/list?customerCode=${req.customerCode}&status=${req.status}`);
}

export function getPOOptions(req) {
  return eHubApi.get(
    `/api/po/options?customerCode=${req.customerCode}&vendorCode=${req.vendorCode}`
  );
}

export function uploadPO(req) {
  return eHubApi.post("/api/po/upload", req);
}

export function getPOStatusCount(req) {
  return eHubApi.get(`/api/po/get-status-count?customerCode=${req.customerCode}`);
}

export function getPOLog(req) {
  return eHubApi.get(`/api/po/log?poNumber=${req.poNumber}&customerCode=${req.customerCode}`);
}

export function createASN(req) {
  return eHubApi.post("/api/asn/create", req);
}

export function editASN(req) {
  return eHubApi.put(
    `/api/asn/edit?asnNumber=${req.asnNumber}&customerCode=${req.customerCode}`,
    req.req
  );
}

export function getASN(req) {
  return eHubApi.get(`/api/asn/get?asnNumber=${req.asnNumber}&customerCode=${req.customerCode}`);
}

export function deleteASN(req) {
  return eHubApi.del(
    `/api/asn/delete?asnNumber=${req.asnNumber}&customerCode=${req.customerCode}&vendorCode=${req.vendorCode}`
  );
}

export function getASNList(req) {
  return eHubApi.get(`/api/asn/list?customerCode=${req.custCode}&status=${req.status}`);
}

export function getASNOptions(req) {
  return eHubApi.get(
    `/api/asn/options?customerCode=${req.customerCode}&vendorCode=${req.vendorCode}`
  );
}

export function verifyASNDetail(req) {
  return eHubApi.post("/api/asn/verify", req);
}

export function getOpenASN(req) {
  return eHubApi.get(`/api/asn/get-open-asn?asnNumber=${req.asnNumber}`);
}

export function getASNStatusCount(req) {
  return eHubApi.get(`/api/asn/get-status-count?customerCode=${req.custCode}`);
}

export function getSKUCode(id) {
  return eHubApi.get(`/api/receiving/getSKUCode/${id}`);
}

export function getPackType(sku, cust) {
  return eHubApi.get(`/api/receiving/getPackType?sku=${sku}&cust=${cust}`);
}

export function getRecvWork(req) {
  return eHubApi.get(
    `/api/recv/get-recv-work?customerCode=${req.customerCode}&vendorCode=${req.vendorCode}&vDONo=${req.vDONo}`
  );
}

export function getVDONo(req) {
  return eHubApi.get(`/api/recv/get-vdono?vendorCode=${req.vendorCode}`);
}

export function getVDONoForCO(req) {
  return eHubApi.get(`/api/CORecv/get-vdono?vendorCode=${req.vendorCode}`);
}

export function createReceiving(req) {
  return eHubApi.post("/api/recv/create", req);
}

export function getReceivingList(req) {
  return eHubApi.get(
    `/api/recv/list?customerCode=${req.custCode}&status=${req.status}&type=${req.type}&queueStatus=${req.queueStatus}`
  );
}

export function createPalletize(req) {
  return eHubApi.post("/api/palletize/create", req);
}

export const cancelPalletize = (req) =>
  eHubApi.del(`/api/palletize/cancel?recvCode=${req.recvCode}`);

export function getPalletItems(req) {
  return eHubApi.get(`/api/palletize/get-pallet-items?recvCode=${req.recvCode}`);
}

export function editReceiving(req) {
  return eHubApi.put(`/api/recv/edit?recvCode=${req.recvCode}`, req.req);
}

export function deleteReceiving(req) {
  return eHubApi.del(`/api/recv/delete?recvCode=${req.recvCode}`);
}

export function getReceiving(req) {
  return eHubApi.get(`/api/recv/get?recvCode=${req.recvCode}`);
}

export function getRecvStatusCount(req) {
  return eHubApi.get(`/api/recv/get-status-count?customerCode=${req.custCode}&type=${req.type}`);
}
export function getRecvQueueStatusCount(req) {
  return eHubApi.get(
    `/api/recv/get-queue-status-count?customerCode=${req.custCode}&type=${req.type}`
  );
}

export function createCO(req) {
  return eHubApi.post("/api/co/create", req);
}

export function editCO(req) {
  return eHubApi.put(`/api/co/edit?coNumber=${req.coNumber}`, req.req);
}

export function getOpenCO(req) {
  return eHubApi.get(`/api/co/get-open-co?coNumber=${req.coNumber}`);
}

export function getOpenCOByVDONo(req) {
  //console.log(" getOpenCOByVDONo req:", req);
  //console.log(" vDONo value:", req?.vDONo);
  //console.log(" vDONo value:", req?.vdono);
  return eHubApi.get(`/api/CORecv/get-open-co-by-vdono?vDONo=${req.vDONo}&customerCode=${req.customerCode}`);
}

export function getCO(coNumber, custCode) {
  return eHubApi.get(`/api/co/get?coNumber=${coNumber}&customerCode=${custCode}`);
}

export function deleteCO(req) {
  return eHubApi.del(`/api/co/delete?coNumber=${req.coNumber}&customerCode=${req.customerCode}`);
}

export function getCOList(req) {
  return eHubApi.get(`/api/co/list?customerCode=${req.customerCode}&status=${req.status}`);
}

export function getCOOptions(req) {
  return eHubApi.get(`/api/co/options?customerCode=${req.customerCode}`);
}

export function uploadCO(req) {
  return eHubApi.post("/api/co/upload", req);
}

export function getCOStatusCount(req) {
  return eHubApi.get(`/api/co/get-status-count?customerCode=${req.customerCode}`);
}

export function createPOReceiving(req) {
  return eHubApi.post("/api/PORecv/create", req);
}

export function getPOReceiving(req) {
  return eHubApi.get(`/api/PORecv/get?recvCode=${req.recvCode}&customerCode=${req.customerCode}`);
}

export function editPOReceiving(req) {
  return eHubApi.put(
    `/api/PORecv/edit?recvCode=${req.recvCode}&customerCode=${req.customerCode}`,
    req.req
  );
}

export function deletePOReceiving(req) {
  return eHubApi.del(
    `/api/PORecv/delete?recvCode=${req.recvCode}&customerCode=${req.customerCode}`
  );
}

export function createCOReceiving(req) {
   //console.log("reach request");
   //console.log("reach requestco",req);
  return eHubApi.post("/api/CORecv/create", req);
}

export function getCOReceiving(req) {
  return eHubApi.get(`/api/CORecv/get?recvCode=${req.recvCode}`);
}

export function editCOReceiving(req) {
  return eHubApi.put(`/api/CORecv/edit?recvCode=${req.recvCode}`, req.req);
}

export function deleteCOReceiving(req) {
  return eHubApi.del(`/api/CORecv/delete?recvCode=${req.recvCode}`);
}

export function getPutawayList(req) {
  return eHubApi.get(
    `/api/putaway/list?customerCode=${req.customerCode}&status=${req.status}&queueStatus=${req.queueStatus}`
  );
}

export function getPutawayStatusCount(req) {
  return eHubApi.get(`/api/putaway/get-status-count?customerCode=${req.customerCode}`);
}

export function getPutawayQueueStatusCount(req) {
  return eHubApi.get(`/api/putaway/get-queue-status-count?customerCode=${req.customerCode}`);
}

export function getASNLog(req) {
  return eHubApi.get(`/api/asn/log?ASNNumber=${req.asnNumber}&customerCode=${req.customerCode}`);
}
export function getReceivingLog(req) {
  return eHubApi.get(`/api/recv/log?recvCode=${req.recvCode}&customerCode=${req.customerCode}`);
}
export function getCOLog(req) {
  return eHubApi.get(`/api/co/log?coNumber=${req.coNumber}&customerCode=${req.customerCode}`);
}
export function getPORecvLog(req) {
  return eHubApi.get(`/api/PORECV/log?recvCode=${req.recvCode}&customerCode=${req.customerCode}`);
}
export function getCORecvLog(req) {
  return eHubApi.get(`/api/CORecv/log?recvCode=${req.recvCode}&customerCode=${req.customerCode}`);
}

export function getRecvQtyLog(req){
  return eHubApi.get(`/api/recv/qty/log?recvCode=${req.recvCode}`)
}

export function getPutaway(req) {
  return eHubApi.get(`/api/putaway/get?putawayId=${req.putawayId}`);
}

export function getPutawayLog(req) {
  return eHubApi.get(`/api/putaway/log?putawayId=${req.putawayId}`);
}

export function createPutaway(req) {
  return eHubApi.post("/api/putaway/create", req);
}
export function confirmPutaway(req) {
  return eHubApi.post("/api/putaway/confirm", req);
}

export function editPutaway(req) {
  return eHubApi.put(`/api/putaway/edit?putawayId=${req.putawayId}`, req.req);
}

export const cancelPutaway = (req) => eHubApi.del(`/api/putaway/cancel?putawayId=${req.putawayId}`);

export const getCancelOrders =(req)=> eHubApi.get(`/api/scanner/putaway/order/list?customer_code=${req.customer_code}`)

export const getCancelOrder =(req)=>eHubApi.get(`/api/scanner/putaway/order/get?customer_code=${req.customer_code}&order_number=${req.order_number}`)

export const confirmCancelOrder =(req)=>eHubApi.post("/api/scanner/putaway/order/confirm",req)

export const editPTO=(req)=>eHubApi.post("/api/scanner/putaway/order/edit",req)

export const addPTO=(req)=>eHubApi.post("/api/scanner/putaway/order/add",req)

export const deletePTO=(req)=>eHubApi.post("/api/scanner/putaway/order/delete",req)

export const getRecvConfirmList = (req) => eHubApi.get(`/api/snt/recv/list?customerCode=${req.customerCode}`)

export const resendRecvConfirm = (req) => eHubApi.post("/api/snt/recv/resend",req)

export const downloadRecvDivisionGroupTemplate = (req) => eHubApi.post_file(`/api/recv/download?customerCode=${req.customerCode}`, req);

export const getShowDivision = (req) => eHubApi.get(`/api/recv/show-division?customerCode=${req.customerCode}`);

export const getShowCODivision = (req) => eHubApi.get(`/api/CORecv/show-division?customerCode=${req.customerCode}`);

export const downloadCORecvDivisionGroupTemplate = (req) =>
  eHubApi.post_file(`/api/adjustment/download`, req);

export const validateRecvDivisionUploadData = (req) => eHubApi.post("/api/recv/division/validate",req);

// export function getRecvReport(req) {
//   return eHubApi.post_file("/api/report/get-recv-report", req);
// }

// export function getPickslipReport(req) {
//   return eHubApi.post_file("/api/report/get-pickslip-report", req);
// }

 